import type { SVGProps } from "react";

export function ReplyIcon( props: SVGProps<SVGSVGElement> ) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            <path
                d="M1.75098 10.1504C1.75098 5.73039 5.33498 2.15039 9.75598 2.15039H14.122C18.612 2.15039 22.251 5.79039 22.251 10.2804C22.251 13.2404 20.644 15.9604 18.055 17.3904L10.001 21.8504V18.1604H9.93398C5.44398 18.2604 1.75098 14.6504 1.75098 10.1504ZM9.75598 4.15039C6.43898 4.15039 3.75098 6.84039 3.75098 10.1504C3.75098 13.5204 6.52098 16.2304 9.88898 16.1604L10.24 16.1504H12.001V18.4504L17.088 15.6404C19.039 14.5604 20.251 12.5104 20.251 10.2804C20.251 6.89039 17.507 4.15039 14.122 4.15039H9.75598Z"
                fill="currentColor"
            />
        </svg>
    );
}

interface LikeIconProps extends SVGProps<SVGSVGElement> {
    liked?: boolean;
}

export function LikeIcon( { liked, ...props }: LikeIconProps ) {
    if ( liked ) {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                {...props}
            >
                <path
                    d="M16.5 3C14.76 3 13.09 3.81 12 5.09C10.91 3.81 9.24 3 7.5 3C4.42 3 2 5.42 2 8.5C2 12.28 5.4 15.36 10.55 20.04L12 21.35L13.45 20.03C18.6 15.36 22 12.28 22 8.5C22 5.42 19.58 3 16.5 3Z"
                    fill="var(--ui-state-danger)"
                />
            </svg>
        );
    }

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            <path
                d="M16.5 3C14.76 3 13.09 3.81 12 5.09C10.91 3.81 9.24 3 7.5 3C4.42 3 2 5.42 2 8.5C2 12.28 5.4 15.36 10.55 20.04L12 21.35L13.45 20.03C18.6 15.36 22 12.28 22 8.5C22 5.42 19.58 3 16.5 3ZM12.1 18.55L12 18.65L11.9 18.55C7.14 14.24 4 11.39 4 8.5C4 6.5 5.5 5 7.5 5C9.04 5 10.54 5.99 11.07 7.36H12.94C13.46 5.99 14.96 5 16.5 5C18.5 5 20 6.5 20 8.5C20 11.39 16.86 14.24 12.1 18.55Z"
                fill="currentColor"
            />
        </svg>
    );
}
